import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-obc-cell-committee',
  templateUrl: './obc-cell-committee.component.html',
  styleUrls: ['./obc-cell-committee.component.scss']
})
export class ObcCellCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
